<template>
  <div class='container'
       ref="containerBox"
       @scroll="handleScroll">
    <div ref="stickyBox"
         :class="[{ sticky: isSticky }, { box: !isSticky }]"
         :style="{ background: isSticky ? '#fff' : 'transparent' }">
      <titlePage :isSticky="isSticky"
                 :scrollToTop="scrollToTop"></titlePage>
    </div>
    <div class='contentBox'>
      <div class="content">
        <div class="list-box flex-column"
             style="margin-top: 30px;">
          <div class="list-item"
               style="display: flex; flex-direction: column;padding: 0;margin-right: 0;">
            <div class="GradientBackground bold"
                 style="font-size: 22px;background: #0092FF;color: #fff;">
              发票抬头信息
            </div>
            <div class="card"
                 style="border-radius: 0 0 10px 10px;padding: 30px 100px;font-size: 16px;">
              <!-- <div class="flex">
                            <div class="label">公司抬头</div>
                            <div>前锦网络信息技术(上海)有限公司武汉分公司</div>
                        </div> -->
              <el-form ref="form"
                       :model="info"
                       label-width="160px">
                <el-form-item label="公司抬头">
                  {{ info.invoice.title || '' }}
                </el-form-item>
                <el-form-item label="统一社会信用代码">
                  {{ info.invoice.code || '' }}
                </el-form-item>
                <el-form-item label="发票地址">
                  {{ info.invoice.address || '' }}
                </el-form-item>
                <el-form-item label="发票电话">
                  {{ info.invoice.phone || '' }}
                </el-form-item>
                <el-form-item label="开户行">
                  {{ info.invoice.bank || '' }}
                </el-form-item>
                <el-form-item label="账号">
                  {{ info.invoice.bank_code || '' }}
                </el-form-item>
                <el-form-item label="发票收件信息">
                  {{ info.invoice.delivery_address || '' }}
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
        <div class="list-box flex-column"
             style="margin-top: 30px;">
          <div class="list-item"
               style="display: flex; flex-direction: column;padding: 0;margin-right: 0;">
            <div class="card"
                 style="border-radius: 10px;">
              <div class="flex-between"
                   style="margin: 10px 0;">
                <div class="tags flex-column"
                     style="padding: 0 20px;">
                  <p>候选人姓名</p>
                  <p>{{ info.people_info.name || "" }}</p>
                </div>
                <div class="tags flex-column "
                     style="padding: 0 20px;"
                     v-if="info.company">
                  <p>职位名称</p>
                  <p>{{ info.company.title || '' }}</p>
                </div>
                <div class="tags flex-column "
                     style="padding: 0 20px;"
                     v-if="info.company">
                  <p>公司名称</p>
                  <p>{{ info.company.company || '' }}</p>
                </div>
                <div class="tags flex-column "
                     style="padding: 0 20px;">
                  <p>经纪人</p>
                  <p> {{ info.user_name || '' }}</p>
                </div>
                <div class="tags flex-column "
                     style="padding: 0 20px;">
                  <p>奖金描述</p>
                  <p>{{ info.remark || '' }}</p>
                </div>
                <div class="tags flex-column "
                     style="padding: 0 20px;">
                  <p>金额</p>
                  <p style="color: #0092FF;">{{ info.pay_fee || '' }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <fotterVue></fotterVue>
  </div>
</template>

<script>
import titlePage from '@/components/titlePage.vue'
import fotterVue from '@/components/fotter.vue'
export default {
  name: '',
  components: {
    titlePage,
    fotterVue,
  },
  data() {
    return {
      list: [],
      info: {},
      isSticky: false,
      stickyBoxTop: 0,
    }
  },
  computed: {},
  watch: {},
  methods: {
    getMyOrderPayDetailt() {
      let data = {
        id: this.$route.query.id,
      }
      console.log(data, 'data')
      this.$api.index.getMyOrderPayDetailt(data).then((res) => {
        console.log(res, '666')
        this.loading = false
        if (res.code == 200) {
          this.info = res.data
        }
      })
    },
    handleScroll(event) {
      const scrollTop = event.target.scrollTop
      this.isSticky = scrollTop > this.stickyBoxTop
    },
    scrollToTop() {
      // this.$refs.containerBox.scrollTop = 0;
      console.log(this.$refs)
    },
  },
  created() {},
  mounted() {
    this.scrollToTop()
    this.getMyOrderPayDetailt()
  },
}
</script>
<style lang='scss' scoped>
.contentBox {
  background: linear-gradient(0deg, #f6f8fe 0%, #f6f8fe 78%, #ceeaff 100%);
  margin-top: 60px;
}

.content {
  padding: 30px 0;
}

.serchBox {
  width: 70%;
  border: 2px solid #0092ff;
  border-radius: 6px;
}

.tags {
  padding: 0 10px;
  font-weight: 400;
  font-size: 14px;
  color: #666;

  p {
    // margin: 0;
    // padding: 0;

    &:last-child {
      color: #333333;
    }
  }
}

.tagsBorder {
  border-left: 1px solid #d7d7d7;
}

::v-deep .el-tabs__nav-wrap::after {
  background-color: transparent !important;
}

::v-deep .el-tabs__active-bar {
  background-color: transparent !important;
}

::v-deep .el-input--suffix .el-input__inner {
  padding: 23px 30px;
}

::v-deep .el-form-item__label {
  color: #979797 !important;
  font-size: 16 !important;
}

::v-deep .el-form-item {
  margin-bottom: 0px !important;
}
</style>